import { render, staticRenderFns } from "./menus-static.vue?vue&type=template&id=1bd42a20&lang=pug"
import script from "./menus-static.vue?vue&type=script&lang=coffee"
export * from "./menus-static.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports